/* Apparitions au scroll + façades vidéo. Chargé en defer sur toutes les pages. */
(function () {
  var d = document.documentElement;
  window.__motionOK = true; /* lu par le garde-fou inline de layout/theme.liquid */

  function tous() {
    return document.querySelectorAll('.reveal, .reveal-stagger');
  }

  function toutMontrer() {
    tous().forEach(function (el) { el.classList.add('is-visible'); });
  }

  /* Façade YouTube : la vidéo (domaine nocookie) ne charge qu'au clic */
  document.querySelectorAll('button.vmedia[data-yt]').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var id = btn.getAttribute('data-yt');
      var f = document.createElement('iframe');
      f.src = 'https://www.youtube-nocookie.com/embed/' + id + '?autoplay=1&mute=1&playsinline=1&rel=0';
      f.title = 'Vidéo';
      f.setAttribute('allow', 'autoplay; encrypted-media');
      f.setAttribute('referrerpolicy', 'strict-origin-when-cross-origin');
      btn.innerHTML = '';
      btn.appendChild(f);
    }, { once: true });
  });

  /* Apparitions au scroll : IntersectionObserver, garde-fous compris */
  if (!('IntersectionObserver' in window)) {
    d.classList.remove('js');
    return;
  }
  if (window.matchMedia && matchMedia('(prefers-reduced-motion: reduce)').matches) {
    toutMontrer();
    return;
  }
  try {
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) {
          e.target.classList.add('is-visible');
          io.unobserve(e.target);
        }
      });
    }, { threshold: 0.15, rootMargin: '0px 0px -8% 0px' });
    tous().forEach(function (el) { io.observe(el); });
  } catch (err) {
    toutMontrer();
  }
})();

/* Compteur animé : le premier nombre d'un [data-compteur] monte de 0 à sa
   valeur quand l'élément apparaît (ex. « +230 000 riders »). L'élément doit
   être en texte pur, sans balise enfant. Sans IO ou en mouvement réduit, la
   valeur finale reste affichée telle quelle. */
(function () {
  var els = document.querySelectorAll('[data-compteur]');
  if (!els.length) return;
  if (!('IntersectionObserver' in window)) return;
  if (window.matchMedia && matchMedia('(prefers-reduced-motion: reduce)').matches) return;

  function formate(n) {
    return String(n).replace(/\B(?=(\d{3})+(?!\d))/g, ' ');
  }

  function anime(el) {
    var texte = el.textContent;
    var m = texte.match(/\d[\d\s  ]*\d|\d/);
    if (!m) return;
    var cible = parseInt(m[0].replace(/\D/g, ''), 10);
    if (!cible) return;
    var debut = parseInt(el.getAttribute('data-compteur'), 10) || 0;
    if (debut >= cible) debut = 0;
    var avant = texte.slice(0, m.index);
    var apres = texte.slice(m.index + m[0].length);
    /* le nombre vit dans un span a largeur figee (mesuree sur la valeur
       finale) en chiffres tabulaires : sinon sa largeur varie a chaque
       image et fait vibrer le texte qui suit (retour Valentin) */
    var span = document.createElement('span');
    span.style.fontVariantNumeric = 'tabular-nums';
    span.textContent = formate(cible);
    el.textContent = '';
    el.appendChild(document.createTextNode(avant));
    el.appendChild(span);
    el.appendChild(document.createTextNode(apres));
    span.style.display = 'inline-block';
    span.style.width = span.offsetWidth + 'px';
    var duree = 1600;
    var depart = null;
    function pas(t) {
      if (depart === null) depart = t;
      var p = Math.min((t - depart) / duree, 1);
      var e = 1 - Math.pow(1 - p, 3);
      span.textContent = formate(Math.round(debut + (cible - debut) * e));
      if (p < 1) requestAnimationFrame(pas);
    }
    requestAnimationFrame(pas);
  }

  try {
    var ioC = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) {
          ioC.unobserve(e.target);
          anime(e.target);
        }
      });
    }, { threshold: 0.6 });
    els.forEach(function (el) { ioC.observe(el); });
  } catch (err) {}
})();

/* En-têtes de section sur une ligne (mobile) : réduit la police des
   sur-titres (.kicker) et titres (.h2) qui débordent, planchers 10 et 17 px.
   Si même le plancher ne suffit pas (ex. titre de la bannière kits déco,
   volontairement grand dans un bloc étroit), on rend le comportement
   d'origine et le texte reprend ses lignes. */
(function () {
  var mq = window.matchMedia('(max-width: 819px)');

  function ajuste() {
    document.querySelectorAll('.kicker, .h2').forEach(function (el) {
      el.style.fontSize = '';
      el.style.whiteSpace = '';
      if (!mq.matches) return;
      var plancher = el.classList.contains('h2') ? 17 : 10;
      /* largeur disponible mesurée AVANT le nowrap : dans une grille, la
         colonne s'étire sinon avec le texte et le débordement devient
         indétectable (cas du titre de la bannière kits déco) */
      var dispo = el.clientWidth;
      el.style.whiteSpace = 'nowrap';
      var taille = parseFloat(getComputedStyle(el).fontSize);
      var garde = 60;
      while (el.scrollWidth > dispo && taille > plancher && garde--) {
        taille -= 0.5;
        el.style.fontSize = taille + 'px';
      }
      if (el.scrollWidth > dispo) {
        el.style.fontSize = '';
      }
      /* le nowrap ne sert qu'à la mesure : un texte qui tient à la taille
         retenue ne se coupera pas sans lui, et le laisser en place peut
         étirer une colonne de grille (bannière kits déco) */
      el.style.whiteSpace = '';
    });
  }

  var minuteur;
  window.addEventListener('resize', function () {
    clearTimeout(minuteur);
    minuteur = setTimeout(ajuste, 150);
  });
  if (document.fonts && document.fonts.ready) document.fonts.ready.then(ajuste);
  ajuste();
})();

/* Défilés de photos et vidéos (team, communauté) : chargement par section.
   Les <img data-defile-src> et <video data-defile-poster> d'une même piste
   reçoivent leur src / poster d'un seul coup quand la piste approche de
   l'écran (1 500 px), donc jamais une case vide au milieu du défilé ; et
   l'animation est mise en pause quand l'onglet est caché, elle ne peut plus
   avancer sur des cases pas encore peintes (retour Valentin 2026-09-04,
   audit 2026-09-06).
   Vidéos (médias Instagram copiés par le Worker) : lecture en muet et en
   boucle seulement quand la tuile est visible, pause sinon et quand l'onglet
   est caché ; rien en lecture auto si l'utilisateur préfère moins de
   mouvement. */
(function () {
  var cibles = document.querySelectorAll('img[data-defile-src], video[data-defile-poster]');
  if (!cibles.length) return;
  var pistes = [];
  cibles.forEach(function (el) {
    var piste = el.closest('.igtrack, .comm-track') || el.parentNode;
    if (pistes.indexOf(piste) === -1) pistes.push(piste);
  });
  var moinsDeMouvement = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var visibles = [];

  function jouer(video) {
    if (moinsDeMouvement || document.hidden) return;
    var p = video.play();
    if (p && p.catch) p.catch(function () {});
  }

  function observerVideos(piste) {
    var videos = piste.querySelectorAll('video');
    if (!videos.length || !('IntersectionObserver' in window)) return;
    var ioV = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        var i = visibles.indexOf(e.target);
        if (e.isIntersecting) {
          if (i === -1) visibles.push(e.target);
          jouer(e.target);
        } else {
          if (i !== -1) visibles.splice(i, 1);
          e.target.pause();
        }
      });
    }, { threshold: 0 });
    videos.forEach(function (v) { ioV.observe(v); });
  }

  function charger(piste) {
    piste.querySelectorAll('img[data-defile-src]').forEach(function (img) {
      img.src = img.getAttribute('data-defile-src');
      img.removeAttribute('data-defile-src');
    });
    piste.querySelectorAll('video[data-defile-poster]').forEach(function (v) {
      v.poster = v.getAttribute('data-defile-poster');
      v.removeAttribute('data-defile-poster');
    });
    observerVideos(piste);
  }

  if ('IntersectionObserver' in window) {
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (!e.isIntersecting) return;
        charger(e.target);
        io.unobserve(e.target);
      });
    }, { rootMargin: '1500px 0px' });
    pistes.forEach(function (piste) { io.observe(piste); });
  } else {
    pistes.forEach(charger);
  }
  document.addEventListener('visibilitychange', function () {
    pistes.forEach(function (piste) {
      /* valeur vide : on rend la main au CSS (pause au survol comprise) */
      piste.style.animationPlayState = document.hidden ? 'paused' : '';
    });
    visibles.forEach(function (v) {
      if (document.hidden) { v.pause(); } else { jouer(v); }
    });
  });
})();

/* Défilés glissables (team, communauté) : la piste avance toute seule comme
   avant, mais on peut la saisir à la souris ou au doigt pour revenir en
   arrière ou avancer plus vite, avec une petite inertie au lâcher, puis le
   défilé reprend de lui-même (demande Valentin 2026-09-07).
   - Le JS reprend l'animation CSS là où elle en est (pas de saut) ; sans JS,
     l'animation CSS continue seule.
   - Vitesse lue sur l'animation-duration de la piste, donc 0 en mouvement
     réduit (le glisser reste possible).
   - Boucle : la piste contient deux passes identiques, l'offset est replié
     sur la largeur d'une passe.
   - Pause comme le CSS : survol à la souris, focus clavier (focus-visible
     seulement : un clic souris qui laisse le focus sur une tuile ne doit pas
     figer le défilé) ; rien ne tourne hors écran ni onglet caché.
   - Un glisser de plus de 6 px annule le clic qui suit, sinon le lien de la
     tuile s'ouvrirait au lâcher. touch-action: pan-y (critical.css) laisse
     le défilement vertical de la page au navigateur. */
(function () {
  if (!window.requestAnimationFrame || !window.PointerEvent) return;

  function installer(wrap) {
    var piste = wrap.querySelector('.igtrack, .comm-track');
    if (!piste || !piste.children.length) return;

    var cs = getComputedStyle(piste);
    var dureeMs = (parseFloat(cs.animationDuration) || 0) * 1000;
    var x = 0;
    var m = cs.transform && cs.transform.match(/matrix\(([^)]+)\)/);
    if (m) x = parseFloat(m[1].split(',')[4]) || 0;
    piste.style.animation = 'none';
    wrap.classList.add('defile-js');

    var moitie = 0;       /* largeur d'une passe, px */
    var vitesse = 0;      /* auto-défilement, px/ms, positif */
    var v = 0;            /* vélocité courante, px/ms, négatif = vers la gauche */
    var glisse = false;   /* pointeur posé */
    var aBouge = false;   /* seuil de glisser franchi */
    var clicAnnule = false;
    var survol = false;
    var visible = true;
    var rafId = 0;
    var derniereT = 0;
    var pointeurId = null;
    var departX = 0;
    var dernierX = 0;
    var derniereTMove = 0;
    var vPointeur = 0;
    var dernierRendu = null;

    function mesurer() {
      moitie = piste.offsetWidth / 2;
      vitesse = dureeMs > 0 && moitie > 0 ? moitie / dureeMs : 0;
    }

    function focusClavier() {
      try { return wrap.querySelector(':focus-visible') !== null; } catch (err) { return false; }
    }

    function rendre() {
      if (moitie > 0) {
        x = x % moitie;
        if (x > 0) x -= moitie;
      }
      var r = x.toFixed(2);
      if (r === dernierRendu) return;
      dernierRendu = r;
      piste.style.transform = 'translate3d(' + r + 'px, 0, 0)';
    }

    function pas(t) {
      rafId = 0;
      if (!visible) return;
      if (!moitie) mesurer();
      var dt = derniereT ? Math.min(t - derniereT, 50) : 16;
      derniereT = t;
      if (!glisse) {
        var cible = (survol || focusClavier()) ? 0 : -vitesse;
        /* l'inertie du lâcher se fond dans la vitesse de croisière */
        v = cible + (v - cible) * Math.pow(0.94, dt / 16.7);
        if (Math.abs(v - cible) < 0.002) v = cible;
        x += v * dt;
      }
      rendre();
      planifier();
    }

    function planifier() {
      if (!rafId && visible) rafId = requestAnimationFrame(pas);
    }

    wrap.addEventListener('pointerdown', function (e) {
      if (pointeurId !== null) return;
      if (e.pointerType === 'mouse' && e.button !== 0) return;
      pointeurId = e.pointerId;
      glisse = true;
      aBouge = false;
      clicAnnule = false;
      v = 0;
      departX = dernierX = e.clientX;
      derniereTMove = e.timeStamp;
      vPointeur = 0;
      try { wrap.setPointerCapture(e.pointerId); } catch (err) {}
      planifier();
    });

    wrap.addEventListener('pointermove', function (e) {
      if (e.pointerId !== pointeurId) return;
      var dx = e.clientX - dernierX;
      var dt = e.timeStamp - derniereTMove;
      dernierX = e.clientX;
      derniereTMove = e.timeStamp;
      if (!aBouge) {
        if (Math.abs(e.clientX - departX) <= 6) return;
        aBouge = true;
        wrap.classList.add('is-dragging');
      }
      x += dx;
      if (dt > 0) vPointeur = 0.7 * (dx / dt) + 0.3 * vPointeur;
      rendre();
    });

    function lacher(e, annule) {
      if (e.pointerId !== pointeurId) return;
      pointeurId = null;
      glisse = false;
      wrap.classList.remove('is-dragging');
      try { wrap.releasePointerCapture(e.pointerId); } catch (err) {}
      if (!aBouge) return;
      clicAnnule = true;
      setTimeout(function () { clicAnnule = false; }, 400);
      /* doigt immobile avant de lâcher : pas d'inertie ; sinon bornée */
      var immobile = annule || e.timeStamp - derniereTMove > 100;
      v = immobile ? 0 : Math.max(-3, Math.min(3, vPointeur));
      derniereT = 0;
      planifier();
    }
    wrap.addEventListener('pointerup', function (e) { lacher(e, false); });
    wrap.addEventListener('pointercancel', function (e) { lacher(e, true); });

    wrap.addEventListener('click', function (e) {
      if (!clicAnnule) return;
      e.preventDefault();
      e.stopPropagation();
    }, true);
    wrap.addEventListener('dragstart', function (e) { e.preventDefault(); });

    wrap.addEventListener('pointerenter', function (e) { if (e.pointerType === 'mouse') survol = true; });
    wrap.addEventListener('pointerleave', function (e) { if (e.pointerType === 'mouse') survol = false; });

    if ('IntersectionObserver' in window) {
      try {
        var io = new IntersectionObserver(function (entries) {
          entries.forEach(function (en) {
            visible = en.isIntersecting;
            if (visible) { derniereT = 0; planifier(); }
          });
        }, { rootMargin: '100px 0px' });
        io.observe(wrap);
      } catch (err) {}
    }

    var minuteur;
    window.addEventListener('resize', function () {
      clearTimeout(minuteur);
      minuteur = setTimeout(mesurer, 150);
    });

    mesurer();
    rendre();
    planifier();
  }

  document.querySelectorAll('.igwrap, .comm-wrap').forEach(installer);
})();
